import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '../../lib/utils';

function Checkbox({ className, ...props }) {
  return (
    <div className="inline-flex items-center justify-center rounded-[12px] p-1">
      <CheckboxPrimitive.Root
        data-slot="checkbox"
        className={cn(
          'peer border-input dark:bg-input/30',
          'data-[state=checked]:bg-[var(--q3-accent-normal)] data-[state=checked]:border-[var(--q3-accent-normal)]',
          'focus-visible:border-ring focus-visible:ring-ring/50',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          'size-4 shrink-0 rounded-[4px] border transition-shadow outline-none focus-visible:ring-[3px]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex rounded-[12px] items-center justify-center transition-none text-[var(--q3-surface-default)]"
        >
          <CheckIcon className="size-3.5" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    </div>
  );
}

export { Checkbox };
